// translations/pages/events/pl.js
// Labels of the events section and page, and the texts of every event by its id
// from config/events.cjs. Dates are not written here; the pages format them.

export const eventsPagePL = {
  title: 'Wydarzenia',
  upcoming: 'Nadchodzące wydarzenia',
  past: 'Minione wydarzenia',
  all: 'Wszystkie wydarzenia',
  items: {
    wikki26: {
      title: 'WiKKI26 – konferencja o sztucznej inteligencji w Wildau',
      description: 'Firma pAIoneer Labs była wystawcą na uczelni Technische Hochschule Wildau. Tematem stoiska było to, jak buduje się lokalną infrastrukturę AI w firmach i organizacjach: suwerenność danych, ochrona danych w fazie projektowania i zgodna z prawem AI, bez zbędnej zależności od zewnętrznych rozwiązań chmurowych.'
    }
  }
};
